/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: nRBm3CMHiqeQ

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import SectionHeader from "../../SectionHeader"; // plasmic-import: BZA1gY3bmqLJ/component
import TextWithIcon from "../../TextWithIcon"; // plasmic-import: qcwxqLdHUKR4/component

import { useScreenVariants as useScreenVariantsgibwEjXEmhF1 } from "./PlasmicGlobalVariant__Mobile"; // plasmic-import: GIBWEjXEmhF1/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicPricingWhySection.module.css"; // plasmic-import: nRBm3CMHiqeQ/css

createPlasmicElementProxy;

export type PlasmicPricingWhySection__VariantMembers = {};
export type PlasmicPricingWhySection__VariantsArgs = {};
type VariantPropType = keyof PlasmicPricingWhySection__VariantsArgs;
export const PlasmicPricingWhySection__VariantProps =
  new Array<VariantPropType>();

export type PlasmicPricingWhySection__ArgsType = {};
type ArgPropType = keyof PlasmicPricingWhySection__ArgsType;
export const PlasmicPricingWhySection__ArgProps = new Array<ArgPropType>();

export type PlasmicPricingWhySection__OverridesType = {
  whySection?: Flex__<"section">;
  wrapper?: Flex__<"div">;
  header?: Flex__<"div">;
  col1?: Flex__<"div">;
  sectionHeader?: Flex__<typeof SectionHeader>;
  items?: Flex__<"div">;
  row?: Flex__<"div">;
  row2?: Flex__<"div">;
};

export interface DefaultPricingWhySectionProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicPricingWhySection__RenderFunc(props: {
  variants: PlasmicPricingWhySection__VariantsArgs;
  args: PlasmicPricingWhySection__ArgsType;
  overrides: PlasmicPricingWhySection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = ensureGlobalVariants({
    mobile: useScreenVariantsgibwEjXEmhF1()
  });

  return (
    <Stack__
      as={"section"}
      data-plasmic-name={"whySection"}
      data-plasmic-override={overrides.whySection}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.whySection
      )}
    >
      <Stack__
        as={"div"}
        data-plasmic-name={"wrapper"}
        data-plasmic-override={overrides.wrapper}
        hasGap={true}
        className={classNames(projectcss.all, sty.wrapper)}
      >
        <Stack__
          as={"div"}
          data-plasmic-name={"header"}
          data-plasmic-override={overrides.header}
          hasGap={true}
          className={classNames(projectcss.all, sty.header)}
        >
          <Stack__
            as={"div"}
            data-plasmic-name={"col1"}
            data-plasmic-override={overrides.col1}
            hasGap={true}
            className={classNames(projectcss.all, sty.col1)}
          >
            <SectionHeader
              data-plasmic-name={"sectionHeader"}
              data-plasmic-override={overrides.sectionHeader}
              className={classNames("__wab_instance", sty.sectionHeader)}
              description={``}
              showSubtitle={true}
              subtitle={"Why MyEvaluations"}
              title={
                "What Sets Us Apart: MyEvaluations' Unique Edge in Medical Education Software"
              }
            />
          </Stack__>
        </Stack__>
        <Stack__
          as={"div"}
          data-plasmic-name={"items"}
          data-plasmic-override={overrides.items}
          hasGap={true}
          className={classNames(projectcss.all, sty.items)}
        >
          <Stack__
            as={"div"}
            data-plasmic-name={"row"}
            data-plasmic-override={overrides.row}
            hasGap={true}
            className={classNames(projectcss.all, sty.row)}
          >
            <TextWithIcon
              className={classNames("__wab_instance", sty.textWithIcon__xl7H0)}
              text={
                "At MyEvaluations, collaboration shapes our system. Partners guide its evolution, making it intuitive and enjoyable. Our close relationship with clients ensures a user-friendly experience, tailored by those in the field for seamless integration into daily practices. Stay ahead with future-ready technology, shaped by real user needs."
              }
              title={"User Experience & Adaptiveness"}
            />

            <TextWithIcon
              className={classNames("__wab_instance", sty.textWithIcon__xkI0R)}
              icon={
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__pnfVq)}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/7a4302e35139e1f96b26cf1d9364fe90.svg",
                    fullWidth: 32,
                    fullHeight: 32,
                    aspectRatio: 1
                  }}
                />
              }
              text={
                "At MyEvaluations, our support is personalized. We offer tailored training, 24/7 accessibility, and direct connections to our team, including our CEO and Director of Development. With dedicated client representatives and an on-demand learning library, we ensure a smooth integration of our solutions into your operations."
              }
              title={"Incredible 365/24 Support"}
            />
          </Stack__>
          <Stack__
            as={"div"}
            data-plasmic-name={"row2"}
            data-plasmic-override={overrides.row2}
            hasGap={true}
            className={classNames(projectcss.all, sty.row2)}
          >
            <TextWithIcon
              className={classNames("__wab_instance", sty.textWithIcon__tmqtr)}
              icon={
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__mbYrr)}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/adaf2d5b384355be849ff56cdcf5914c.svg",
                    fullWidth: 32,
                    fullHeight: 32,
                    aspectRatio: 1
                  }}
                />
              }
              text={
                "Connect your systems effortlessly with MyEvaluations. From seamless Single-Sign-On to API integration with EHR/EMR systems, we ensure unified data access. Collaborations with platforms like AMiON and QGenda simplify schedule management and streamline notifications. With us, integration is intuitive and tailored to your needs."
              }
              title={"Out-of-the-Box Integrations"}
            />

            <TextWithIcon
              className={classNames("__wab_instance", sty.textWithIcon__n1CV)}
              icon={
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__jXaSp)}
                  displayHeight={"32px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"32px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/c07561ae449502cfb69657ee3ef85ce9.svg",
                    fullWidth: 32,
                    fullHeight: 32,
                    aspectRatio: 1
                  }}
                />
              }
              text={
                "Our servers undergo regular monitoring and backups, maintaining HIPAA and HITECH compliance. We employ 3072-bit SSL encryption for robust data protection, verified by SecurityMetrics and SSL.com. Your data remains private, not shared with third parties, and our systems are SOC 1 & SOC 2 compliant, ensuring the utmost privacy."
              }
              title={"100% Secure & Private"}
            />
          </Stack__>
        </Stack__>
      </Stack__>
    </Stack__>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  whySection: [
    "whySection",
    "wrapper",
    "header",
    "col1",
    "sectionHeader",
    "items",
    "row",
    "row2"
  ],
  wrapper: [
    "wrapper",
    "header",
    "col1",
    "sectionHeader",
    "items",
    "row",
    "row2"
  ],
  header: ["header", "col1", "sectionHeader"],
  col1: ["col1", "sectionHeader"],
  sectionHeader: ["sectionHeader"],
  items: ["items", "row", "row2"],
  row: ["row"],
  row2: ["row2"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  whySection: "section";
  wrapper: "div";
  header: "div";
  col1: "div";
  sectionHeader: typeof SectionHeader;
  items: "div";
  row: "div";
  row2: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPricingWhySection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPricingWhySection__VariantsArgs;
    args?: PlasmicPricingWhySection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicPricingWhySection__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicPricingWhySection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPricingWhySection__ArgProps,
          internalVariantPropNames: PlasmicPricingWhySection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPricingWhySection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "whySection") {
    func.displayName = "PlasmicPricingWhySection";
  } else {
    func.displayName = `PlasmicPricingWhySection.${nodeName}`;
  }
  return func;
}

export const PlasmicPricingWhySection = Object.assign(
  // Top-level PlasmicPricingWhySection renders the root element
  makeNodeComponent("whySection"),
  {
    // Helper components rendering sub-elements
    wrapper: makeNodeComponent("wrapper"),
    header: makeNodeComponent("header"),
    col1: makeNodeComponent("col1"),
    sectionHeader: makeNodeComponent("sectionHeader"),
    items: makeNodeComponent("items"),
    row: makeNodeComponent("row"),
    row2: makeNodeComponent("row2"),

    // Metadata about props expected for PlasmicPricingWhySection
    internalVariantProps: PlasmicPricingWhySection__VariantProps,
    internalArgProps: PlasmicPricingWhySection__ArgProps
  }
);

export default PlasmicPricingWhySection;
/* prettier-ignore-end */
